export class TaskDocResetLockRequest {
  doNo: string;
  docType: string;
  user: string;
  taskClassName: string;
  doLockHeader: string | null;

  constructor() {
    this.doNo = "";
    this.docType = "";
    this.user = "";
    this.taskClassName = "";
    this.doLockHeader = "";
  }
}
